import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { Api } from '../api/api';
import { Utils } from '../utils/utils';

/*
*
*  User Provider
*
*/

@Injectable()
export class User {

    public data : any = {};
    public idbox: any;
    public isDisconnecting : boolean = false;

    constructor(
        public api: Api,
        public utils: Utils,
        public events: Events
    ) {

    }

    /*
    *    Return current data
    */
    get() {
        return this.data;
    }

    /*
    *    Return bool
    */
    isLogged() {

        if ( !localStorage.getItem('token')) return false;

        if (this.isDisconnecting) return false;
        
        if (this.data.id) return true;

        return false;
    }

    /*
    *    Auth method
    */
    auth(login, password) {

        return new Promise((resolve, reject) => {
            this.api.post('connect', {login : login, password : password}).subscribe((response:any)=>{
                
                if (response.status == 401 || response.errorMessage) {
                    reject('Authentification failed');
                    return false;
                } 

                localStorage.setItem('token', response.result.accessToken);

                // Check for contract
                this.fetch().then(() => {
                    resolve();
                });
                
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }


    /*
    *    Auth method
    */
    authGuest(login, password) {

        return new Promise((resolve, reject) => {
            this.api.post('connectGuest', {login : login, password : password}).subscribe((response:any)=>{
                
                if (response.status == 401 || response.errorMessage) {
                    reject('Authentification failed');
                    return false;
                } 

                localStorage.setItem('token', response.result.accessToken);

                // Check for contract
                this.fetch().then(() => {
                    resolve();
                });
                
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

    /*
    *    Auth From QRCode
    */
    authCode(login, password) {
        return new Promise((resolve, reject) => {
            this.api.post('connectCode', {login : login, password : password}).subscribe((response:any)=>{
                
                if (response.status == 401 || response.errorMessage) {
                    reject('Authentification failed');
                    return false;
                } 

                localStorage.setItem('token', response.result.accessToken);

                // Check for contract
                this.fetch().then(() => {
                    resolve();
                });
                
            },(err) => {
                console.error('authCode', JSON.stringify(err));
                reject(this.api.reject(err));
            });
        });
    }

    /*
    *    Fetch from api
    */
    fetch() {
        return new Promise((resolve, reject) => {
            if ( !localStorage.getItem('token')) {
                reject('Token expired');
            } else {
                this.api.getCached('contact/me', {}, null, 3000).subscribe((response:any)=>{
                    this.data = response.result;
                    resolve();
                },(err) => {
                    reject(this.api.reject(err));
                });
            }
        });
    }

    /*
    *    Is Guest Method
    */
    isGuest() {
        if (this.data.priority && this.data.priority == 'GUEST') return true;
        return false;
    }

    /*
    *    Disconnect
    */
    disconnect(noEvents?:any) {

        // Set Disconnecting attribute
        this.isDisconnecting = true;

        // Promise
        return new Promise((resolve, reject) => {
        
            // Reset From CRM (All Status)
            this.api.get('iptv/reset', {}, null, 3000).subscribe((response:any)=>{
                
                // Force timeout 
                let that = this;

                setTimeout(function() {
                    // Reset user.ts data 
                    that.resetUserData();
    
                    // Realy disconnected events
                    if (!noEvents)  that.events.publish('user:disconnect');
    
                    // Really disconnected attribute
                    that.isDisconnecting = false;
                
                    // Resolve
                    resolve();
                    
                },1000);

            },(err) => {
                 this.isDisconnecting = false;
                 reject(this.api.reject(err));
            });
        });
    }

    /*
    *    Reset user.ts attribute AND Storage data
    */
    resetUserData() {
        this.data = {};
        localStorage.removeItem('token');
        localStorage.removeItem('remoteApp');
        localStorage.clear();
    }

}


// WEBPACK FOOTER //
// ./src/providers/user/user.ts